const TOGGLE_TAG_TO_BE_SEARCHED_CHECK = "TOGGLE_TAG_TO_BE_SEARCHED_CHECK";
const SET_TAG_TO_BE_SEARCHED_CHECK = "SET_TAG_TO_BE_SEARCHED_CHECK";

export { TOGGLE_TAG_TO_BE_SEARCHED_CHECK, SET_TAG_TO_BE_SEARCHED_CHECK };
